import React from 'react';

import { FilterPropertyType, IFiltersOptions } from 'types';

function useFilters(initialValues?: IFiltersOptions[]) {
  const [filters, setFilters] = React.useState<IFiltersOptions[]>(
    initialValues || [],
  );
  const [removedFilter, setRemovedFilter] =
    React.useState<FilterPropertyType>();
  const [isRemovedAll, setIsRemovedAll] = React.useState(false);

  const onRemoveFilter = (filterProperty: FilterPropertyType) => {
    setFilters(filters.filter(filter => filter.property !== filterProperty));
    setRemovedFilter(filterProperty);
  };

  const onRemoveAllFilters = React.useCallback(() => {
    setFilters([]);
    setIsRemovedAll(true);
  }, []);

  const handleReloadStates = () => {
    setIsRemovedAll(false);
    setRemovedFilter(undefined);
  };

  React.useEffect(() => {
    if (removedFilter || isRemovedAll) {
      handleReloadStates();
    }
  }, [isRemovedAll, removedFilter]);

  return {
    filters,
    setFilters,
    onRemoveFilter,
    onRemoveAllFilters,
    removedFilter,
    isRemovedAll,
  };
}

export default useFilters;
